"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = exports.CloseIcon = exports.CloseWrapper = exports.Brand5Button = exports.RoundedButton = exports.ProgressWrapper = exports.StyledPanel = exports.Buttons = exports.EmptyFieldsWrapper = exports.ProgressText = exports.Percentage = exports.ProgressBox = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const icons_1 = require("@ant-design/icons");
const styled_breakpoints_1 = require("styled-breakpoints");
const polished_1 = require("polished");
exports.ProgressBox = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 1rem 1.5rem;
`;
exports.Percentage = styled_components_1.default.div `
	font-size: 1.5rem;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 4rem;
	width: 4rem;
	background: ${({ background }) => background};
	color: white;
	margin-bottom: 1rem;
`;
exports.ProgressText = styled_components_1.default.div `
	font-size: 1rem;
	font-weight: 600;
	margin-bottom: 0.5rem;
	color: ${({ theme }) => theme.color.brand1};
`;
exports.EmptyFieldsWrapper = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	flex-direction: column;
	width: 100%;
	align-items: flex-start;
	flex-wrap: wrap;
	a {
		margin: 0.1rem;
		display: inline-block;
	}
`;
exports.Buttons = styled_components_1.default.div `
	display: flex;
	align-items: center;
	margin-top: 2rem;
	button {
		margin-left: 0.5rem;
	}

	${(0, styled_breakpoints_1.only)('md')} {
		flex-direction: column;
		justify-content: center;
		align-items: flex-end;
		margin-top: 0.5rem;
		button {
			margin: 0.25rem 1rem;
		}
	}

	${(0, styled_breakpoints_1.down)('sm')} {
		margin-top: 1rem;
	}
`;
exports.StyledPanel = (0, styled_components_1.default)(elements_1.Panel) `
	background-color: #dae6f85c;
	position: relative;
	border: none;
	border-radius: ${({ theme }) => theme.borderRadius.large};
	padding: 0;
	margin-bottom: 1rem;
`;
exports.ProgressWrapper = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	width: 30%;
	min-width: 30%;
	align-items: flex-start;
	justify-content: center;
	margin-right: 5rem;

	${(0, styled_breakpoints_1.down)('sm')} {
		width: 90%;
		align-items: center;
		margin: 0;
	}
`;
exports.RoundedButton = (0, styled_components_1.default)(elements_1.Button) `
	border-radius: 12px;
	padding: 0.75rem;
`;
exports.Brand5Button = (0, styled_components_1.default)(elements_1.Button) `
	background-color: ${({ theme }) => theme.color.brand5};
	border: none;
	&:hover {
		background: ${({ theme }) => (0, polished_1.lighten)(0.05, theme.color.brand5)};
	}
	padding: 0.5rem;
`;
exports.CloseWrapper = styled_components_1.default.span `
	position: absolute;
	top: 0.5rem;
	right: 0.5rem;
	cursor: pointer;
`;
exports.CloseIcon = (0, styled_components_1.default)(icons_1.CloseOutlined) `
	color: ${({ theme }) => theme.color.brand4};
	svg {
		width: 1rem;
		height: 1rem;
	}
`;
exports.Container = styled_components_1.default.div `
	display: flex;
	width: 100%;
	${(0, styled_breakpoints_1.down)('sm')} {
		flex-direction: column;
		align-items: center;
	}
`;
